export const AUTHORIZE_VALIDATION='AUTHORIZE_VALIDATION';
export const AUTHORIZE_RENDER_COMPONENTS='AUTHORIZE_RENDER_COMPONENTS';
export const AUTHORIZE_LOAD_TOKEN='AUTHORIZE_LOAD_TOKEN'
export const SET_VALIDATION_UI_LOGIN_FORM='SET_VALIDATION_UI_LOGIN_FORM';
export const EDIT_MAP_STATE='EDIT_MAP_STATE';
export const EDIT_MAP_POINT='EDIT_MAP_POINT';
export const ADD_USER_IDS_FOR_EDIT_AND_DELETE='ADD_USER_IDS_FOR_EDIT_AND_DELETE';
export const DELETE_USER_IDS_FOR_EDIT_AND_DELETE='DELETE_USER_IDS_FOR_EDIT_AND_DELETE';
export const SET_MUNICIPALITY_ID='SET_MUNICIPALITY_ID';
export const SET_USERNAME_DESC='SET_USERNAME_DESC';
export const SET_ISRELOADED='SET_ISRELOADED';
export const SET_ISTEMPORARY='SET_ISTEMPORARY';
export const SET_COUNTOPEN='SET_COUNTOPEN';
export const SET_COUNTPENDING='SET_COUNTPENDING';
// export const SHAKE_MAP_POINT='SHAKE_MAP_POINT';